/**
 * 성별 표기를 한국어 한 글자로 맞춘다.
 *
 * 대상자 테이블(auhm.gender)은 'M' / 'F' 로 들어 있고 화면은 그것을 그대로 찍고 있었다.
 * 한 화면 안에서 "72세 · M · 강남구 보건소" 처럼 한국어 사이에 영문 약자가 끼면 읽는 눈이
 * 한 번 걸린다. 다른 테이블은 '남성' / '여성' 으로 들고 있는 곳도 있어(의사 신청 화면이
 * 그쪽을 M/F 로 다시 옮긴다) 두 모양을 다 받는다.
 *
 * 모르는 값은 **바꾸지 않고 그대로 돌려준다.** 성별은 사람의 정보라, 규칙에 없는 값이
 * 들어왔을 때 임의로 고르거나 지우는 것보다 원본을 보여 주는 편이 낫다.
 */
const MAP = {
    M: '남',
    F: '여',
    남: '남',
    여: '여',
    남성: '남',
    여성: '여',
    MALE: '남',
    FEMALE: '여'
};

/**
 * @param {*} value 원본 성별 값.
 * @returns {*} '남' 또는 '여'. 규칙에 없으면 원본 그대로.
 */
export const formatGender = (value) => {
    if (typeof value !== 'string') return value;
    const key = value.trim().toUpperCase();
    return MAP[key] ?? value;
};

export default formatGender;
